import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateFuneralParlourConstants {
    static PARLOUR_CONTROL = "parlourRecipient";
    static PARLOUR_SELECT_CONTROL = "parlourSelector";
    static PARLOUR_SELECT_LABEL = "Select funeral parlour";
    static PLACE_HOLDER;
    static FUNERAL_PARLOUR_IS_NULL_FORM_CONTROL_NAME = "funeralParlourIsNull";
    static FUNERAL_PARLOUR_IS_NULL_FORM_GROUP_NAME = "funeralParlourForm";
    static NOTICE_LABEL = "If your funeral parlour is not listed, contact your municipality";
    static MARK_FUNERAL_PARLOUR_AS_NOT_APPLICABLE_LABEL = "Mark funeral parlour as not applicable";
    static TITLE = "Funeral parlour";
    static VALIDATION_MESSAGES = {
        parlourRecipientSelect: {
            required: `Funeral parlour ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
